import React from 'react';
import { getRarityInfoByRank } from '../../utils/formatters';

interface RarityRankProps {
  rank: number | null | undefined;
  totalSupply?: number | null;
  showTotal?: boolean;
  className?: string;
}

/**
 * Displays NFT rarity rank with color coding based on percentile
 * - Legendary (top 1%): Gold with shimmer effect
 * - Epic (top 5%): Purple
 * - Rare (top 15%): Blue
 * - Uncommon (top 35%): Green
 * - Common (>35%): Gray
 *
 * Format: "Rank #42" or "Rank #42 / 1,000" (with showTotal)
 * The word "Rank" and the number are both colored based on rarity tier
 *
 * Returns null if rank is null/undefined (NONE methodology collections)
 */
export const RarityRank: React.FC<RarityRankProps> = ({
  rank,
  totalSupply,
  showTotal = false,
  className = '',
}) => {
  // Handle null/undefined rank (NONE methodology)
  if (rank === null || rank === undefined) {
    return null;
  }

  const rarityInfo = totalSupply
    ? getRarityInfoByRank(rank, totalSupply)
    : null;

  const isLegendary = rarityInfo?.tier === 'legendary';

  return (
    <span className={className}>
      <span
        className={isLegendary ? 'legendary-shimmer' : ''}
        style={isLegendary ? undefined : { color: rarityInfo?.color }}
      >
        Rank #{rank.toLocaleString()}
      </span>
      {showTotal && totalSupply && (
        <span className="text-subtext-color">
          {' '}/ {totalSupply.toLocaleString()}
        </span>
      )}
    </span>
  );
};
